import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import type { IRightBarProps } from "pro-features/pages/workspace/common components/RightBar/src/RightBar";

export const StyledRecommendationContainer = styled.div<Partial<IRightBarProps>>`
    position: fixed;
    top: 0;
    right: 0;
    width: 440px;
    height: 100%;
    transform: translateX(${({ isOpen }) => (isOpen ? 0 : "100%")});
    transition: transform 300ms ease-in-out;
    z-index: 1071;
    background-color: ${colorsPalettes.bluegrey[100]};
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
`;

export const StyledRecommendationRefreshButtonWrapper = styled.div`
    margin: -10px 0;
`;

export const StyledRecommendationListTitle = styled.div`
    font-size: 14px;
    display: flex;
    align-items: center;
    line-height: normal;
    color: ${colorsPalettes.black[0]};
`;
export const StyledRecommendationListCountryTitle = styled(StyledRecommendationListTitle)`
    margin: 0 4px 0 0;
    color: ${colorsPalettes.carbon[400]};
`;
export const StyledRecommendationListItemWrapper = styled.div`
    margin-top: -10px;

    &:not(:first-of-type) {
        padding-top: 24px;
    }
`;
